var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{style:(_vm.isMicroApp ? '' : { minWidth: '1024px' }),attrs:{"id":"app"}},[_c('a-config-provider',{attrs:{"locale":_vm.getValidLocale}},[_c('router-view',{on:{"languageChange":_vm.languageChange}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }